import { EMachineType } from 'src/app/enums/machine-type.enum';
import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	ViewChild,
	ElementRef,
	ViewChildren,
	QueryList,
	ViewContainerRef,
	HostListener,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { throttle } from 'lodash';

import { MatMenuTrigger } from '@lenovo/material/menu';

import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { CommonService } from 'src/app/services/common/common.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { DeviceService } from 'src/app/services/device/device.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { CardService } from 'src/app/services/card/card.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { NetworkStatus } from 'src/app/enums/network-status.enum';
import { ModernPreloadService } from 'src/app/services/modern-preload/modern-preload.service';
import { StringBooleanEnum } from 'src/app/data-models/common/common.interface';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { InputAccessoriesCapability } from 'src/app/data-models/input-accessories/input-accessories-capability.model';
import { BacklightService } from 'src/app/components/pages/page-device-settings/children/subpage-device-settings-input-accessory/backlight/backlight.service';
import { TopRowFunctionsIdeapadService } from 'src/app/components/pages/page-device-settings/children/subpage-device-settings-input-accessory/top-row-functions-ideapad/top-row-functions-ideapad.service';
import { BacklightLevelEnum } from 'src/app/components/pages/page-device-settings/children/subpage-device-settings-input-accessory/backlight/backlight.enum';
import { MenuChange } from 'src/app/enums/menuChange.enum';
import { ModernPreloadEnum } from 'src/app/enums/modern-preload.enum';
import { MenuHoverDirective } from 'src/app/directives/menu-hover.directive';
import { TopRowFunctionFeature } from 'src/app/presenters/user-cases/input-accessories/intelligent-keyboard/top-row-function/top-row-function-feature';
import { containerAppService } from '@lenovo/micro-frontends-iframe/container-app/container-app.service';
import { AppMessage } from '@lenovo/micro-frontends-iframe/common/app-message';
import { SubAppSendMessageType } from '@lenovo/micro-frontends-iframe/common/app-message-type';
@Component({
	selector: 'vtr-material-menu',
	templateUrl: './material-menu.component.html',
	styleUrls: ['./material-menu.component.scss'],
})
export class MaterialMenuComponent implements OnInit, OnDestroy {
	@ViewChildren(MenuHoverDirective) hoverTriggers: QueryList<MenuHoverDirective>;
	@ViewChildren(MatMenuTrigger) triggers: QueryList<MatMenuTrigger>;
	@Input() loadMenuItem: any = {};
	VantageLogo = `
		data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c
		3RyYXRvciAyMy4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4x
		IiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS9
		4bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNTYgMj
		U2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMjdBREQ3O30NCgkuc3Qxe2ZpbGw6I
		zIxMzA2NDt9DQoJLnN0MntmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjxnPg0KCTxyZWN0IHk9IjAiIGNsYXNzPSJzdDAiIHdpZHRoPSIyNTYiIGhl
		aWdodD0iMjU2Ii8+DQoJPGc+DQoJCTxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iNTguMiwyMTEuNiA4OC41LDE5Mi42IDE5NC44LDE5Mi42IDE
		5NC44LDE5NS41IAkJIi8+DQoJCTxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iNTguMiwyMTEuNiA4OC41LDE5Mi42IDg4LjUsMzkuNiA4Ni4zLD
		M5LjYgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MiIgcG9pbnRzPSIxOTQuOCwxNjIuOSAxMjEuMywxNjIuOSAxMjEuMywzOS42IDg4LjUsMzkuN
		iA4OC41LDE5Mi42IDE5NC44LDE5Mi42IAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=
		`;
	machineFamilyName: string;
	items: Array<any> = [];
	preloadImages: string[];
	isLoggingOut = false;
	showSearchMenu = false;
	translateSubscription: Subscription;
	unsupportedFeatureSubscription: Subscription;
	searchTips = '';
	showSearchBox = false;
	activeItemId: string;
	currentRoutePath: string;
	private subscription: Subscription;
	private backlightCapabilitySubscription: Subscription;
	private isTopRowFncapable: boolean;
	private routerEventSubscription: Subscription;
	private unsupportFeatureEvt: Observable<string>;
	private searchTipsTimeout: any;
	private closeAllOtherMatMenuTimer: any;
	private receiverId: symbol;
	constructor(
		public dashboardService: DashboardService,
		public configService: ConfigService,
		public deviceService: DeviceService,
		public languageService: LanguageService,
		public commonService: CommonService,
		public modernPreloadService: ModernPreloadService,
		private cardService: CardService,
		private dialogService: DialogService,
		private backlightService: BacklightService,
		private topRowFunctionsIdeapadService: TopRowFunctionsIdeapadService,
		private router: Router,
		private viewContainerRef: ViewContainerRef,
		private translate: TranslateService,
		private logger: LoggerService,
		private keyboardService: InputAccessoriesService,
		private topRowFunctionFeature: TopRowFunctionFeature
	) {}

	ngOnInit(): void {
		const cacheMachineFamilyName = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineFamilyName,
			undefined
		);
		if (cacheMachineFamilyName) {
			this.machineFamilyName = cacheMachineFamilyName;
		}
		this.subscription = this.commonService.notification.subscribe(
			(notification: AppNotification) => {
				this.onNotification(notification);
			}
		);
		this.updateMenu(this.configService.menu);
		this.initComponent();
		window.addEventListener(
			'resize',
			throttle(
				() => {
					this.closeAllMatMenu();
				},
				100,
				{ leading: true }
			)
		);
		this.routerEventSubscription = this.router.events.subscribe((ev) => {
			if (ev instanceof NavigationEnd) {
				this.currentRoutePath = ev.url;
			}
		});
		this.receiverId = containerAppService.addReceiver((appMessage: AppMessage) => {
			if (appMessage.messageType === SubAppSendMessageType.clickInIframe) {
				containerAppService.setHandlerForSubAppClickEvent(appMessage.appName, () => {
					this.closeAllMatMenu();

				});
			}

			containerAppService.doNotSendMetricsForThisReceiverCase();
		});
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		if (this.backlightCapabilitySubscription) {
			this.backlightCapabilitySubscription.unsubscribe();
		}
		if (this.translateSubscription) {
			this.translateSubscription.unsubscribe();
		}
		if (this.unsupportedFeatureSubscription) {
			this.unsupportedFeatureSubscription.unsubscribe();
		}
		if (this.routerEventSubscription) {
			this.routerEventSubscription.unsubscribe();
		}
		containerAppService.removeReceiver(this.receiverId);
	}

	public updateMenu(menu) {
		if (menu && menu.length > 0) {
			this.items = menu;
			this.preloadImages = this.collectPreloadAssets(menu);
			this.updateModernPreload(this.items);
			this.updateDeviceMenu(this.items);
		}
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case LocalStorageKey.MachineFamilyName:
					this.machineFamilyName = notification.payload;
					break;
				case MenuChange.MenuItemChange:
					this.updateMenu(notification.payload);
					break;
				case 'MachineInfo':
					this.machineFamilyName = notification.payload.family;
					this.commonService.setLocalStorageValue(
						LocalStorageKey.MachineFamilyName,
						notification.payload.family
					);
					break;
				case NetworkStatus.Online:
					this.modernPreloadService.getIsEntitled();
					break;
				case ModernPreloadEnum.GetIsEntitledRespond:
				case NetworkStatus.Offline:
					this.updateModernPreload(this.items);
					this.updateDeviceMenu(this.items);
					break;
				default:
					break;
			}
		}
	}

	private updateModernPreload(menu) {
		if (menu) {
			const myDeviceItem = menu.find((item) => item.id === 'device');
			if (myDeviceItem) {
				const subItem = myDeviceItem.subitems.find(
					(item) => item.id === 'device-subcategory'
				);
				if (subItem && subItem.subitems) {
					const modernPreloadItem = subItem.subitems.find(
						(item) => item.id === 'menu-main-lnk-open-modern-preload'
					);
					if (modernPreloadItem) {
						if (!this.commonService.isOnline || !this.modernPreloadService.IsEntitled) {
							modernPreloadItem.hide = true;
						} else {
							modernPreloadItem.hide = false;
						}
					}
				}
			}
		}
	}

	private updateDeviceMenu(menu) {
		if (menu) {
			const deviceMenu = menu.find((item) => item.id === 'device');
			if (!deviceMenu || !deviceMenu.subitems || deviceMenu.subitems.length < 1) {
				return;
			}
			let isAllSubItemHiden = true;
			deviceMenu.subitems.forEach((item) => {
				if (item.subitems) {
					const allHiden = item.subitems.every(
						(element, index, array) => element.hide === true
					);
					if (!allHiden) {
						isAllSubItemHiden = false;
					}
				}
			});
			if (isAllSubItemHiden) {
				deviceMenu.hide = true;
			} else {
				let firstVisibleChild;
				deviceMenu.subitems.forEach((item) => {
					if (item.subitems) {
						const visibleItem = item.subitems.find((element) => element.hide !== true);
						if (visibleItem && !firstVisibleChild) {
							firstVisibleChild = visibleItem;
						}
					}
				});

				if (firstVisibleChild) {
					if (firstVisibleChild.outletLink) {
						deviceMenu.firstVisibleChildLink = firstVisibleChild.outletLink;
					} else {
						deviceMenu.firstVisibleChildLink = firstVisibleChild.path;
					}
				}
			}
		}
	}

	private initComponent() {
		this.translateSubscription = this.translate.onLangChange.subscribe(
			(event: LangChangeEvent) => {
				if (this.translate.currentLang === 'en') {
					this.showSearchMenu = true;
				}
			}
		);

		const machineType = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineType,
			undefined
		);
		if (machineType !== undefined) {
			this.loadMenuOptions(machineType);
		} else if (this.deviceService.isShellAvailable) {
			this.deviceService.getMachineType().then((value: number) => {
				this.loadMenuOptions(value);
			});
		}
	}

	@HostListener('document:click', ['$event'])
	onClick(event) {
		if (!event.fromSearchBox && !event.fromSearchMenu) {
			this.updateSearchBoxState(false);
		}
	}

	updateSearchBoxState(isActive) {
		this.searchTips = '';
		this.showSearchBox = isActive;
		if (isActive && this.searchTipsTimeout) {
			this.searchTipsTimeout = clearTimeout(this.searchTipsTimeout);
			this.searchTipsTimeout = null;
		}
	}

	private async loadMenuOptions(machineType: number) {
		// if IdeaPad then call below function
		if (machineType === 0 || machineType === 1) {
			this.backlightCapabilitySubscription = this.backlightService.backlight
				.pipe(
					map((res) => res.find((item) => item.key === 'KeyboardBacklightLevel')),
					map((res) => res.value !== BacklightLevelEnum.NO_CAPABILITY),
					tap((res) => {
						this.commonService.setLocalStorageValue(
							LocalStorageKey.BacklightCapability,
							res
						);
					}),
					catchError(() => {
						window.localStorage.removeItem(LocalStorageKey.BacklightCapability);
						return undefined;
					})
				)
				.subscribe();
		}
		const machineFamily = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineFamilyName,
			undefined
		);
		// Added special case for KEI machine
		if (machineFamily) {
			const familyName = machineFamily.replace(/\s+/g, '');
			if (machineType === 1 && familyName !== 'LenovoTablet10') {
				this.initInputAccessories();
			}
		}

		this.isTopRowFncapable = await this.topRowFunctionFeature.getCapability();
	}

	async initInputAccessories() {
		this.logger.error('MenuMainComponent.initInputAccessories before API call');
		const responses = await Promise.all([
			this.keyboardService.GetAllCapability(),
			this.keyboardService.GetKeyboardVersion(),
		]);
		try {
			if (responses) {
				this.logger.error('MenuMainComponent.initInputAccessories after API call', {
					GetAllCapability: responses[0],
					GetKeyboardVersion: responses[1],
				});
				let inputAccessoriesCapability: InputAccessoriesCapability =
					this.commonService.getLocalStorageValue(
						LocalStorageKey.InputAccessoriesCapability,
						undefined
					);
				if (inputAccessoriesCapability === undefined) {
					inputAccessoriesCapability = new InputAccessoriesCapability();
				}
				inputAccessoriesCapability.isUdkAvailable =
					responses[0] != null &&
					Object.keys(responses[0]).indexOf('uDKCapability') !== -1
						? responses[0].uDKCapability
						: false;
				inputAccessoriesCapability.isKeyboardMapAvailable =
					responses[0] != null &&
					Object.keys(responses[0]).indexOf('keyboardMapCapability') !== -1
						? responses[0].keyboardMapCapability
						: false;
				inputAccessoriesCapability.keyboardVersion =
					responses[1] != null ? responses[1] : '-1';
				this.commonService.setLocalStorageValue(
					LocalStorageKey.InputAccessoriesCapability,
					inputAccessoriesCapability
				);
			}
		} catch (error) {
			this.logger.exception('initInputAccessories', error);
		}
		this.keyboardService.getVoipHotkeysSettings().then((response) => {
			if (response.capability) {
				this.commonService.setLocalStorageValue(
					LocalStorageKey.VOIPCapability,
					response.capability
				);
			}
			return response;
		});
	}

	toggleMenu(event) {
		this.updateSearchBoxState(false);
		event.stopPropagation();
	}

	private collectPreloadAssets(menu: Array<any>): string[] {
		let assets = [];
		menu.forEach((item) => {
			if (!item.hide && item.pre) {
				assets = assets.concat(item.pre);
			}
			if (item.subitems.length > 0) {
				assets = assets.concat(this.collectPreloadAssets(item.subitems));
			}
		});
		return assets;
	}

	onClickSearchMask() {
		this.updateSearchBoxState(false);
	}

	menuItemKeyDown(path, subpath?) {
		subpath
			? this.router.navigateByUrl(`/${path}/${subpath}`)
			: path
			? this.router.navigateByUrl(`/${path}`)
			: this.router.navigateByUrl(`/`);
	}

	openMatMenu(menuTrigger: MenuHoverDirective) {
		menuTrigger.openMenu();
	}

	closeMatMenu(menuTrigger: MenuHoverDirective) {
		menuTrigger.closeMenu();
	}

	closeAllMatMenu() {
		this.triggers?.toArray().forEach((elem) => {
			elem.closeMenu();
		});
		this.hoverTriggers?.toArray().forEach((elem) => {
			elem.closeMenu();
		});
	}

	handlePointerEnter(activeDropdown: MenuHoverDirective, event) {
		if (this.closeAllOtherMatMenuTimer) {
			this.clearCloseAllOtherMatMenu();
		}
		if (event.pointerType === 'mouse') {
			this.closeAllOtherMatMenuTimer = setTimeout(() => {
				this.closeAllOtherMatMenu(activeDropdown);
				this.clearCloseAllOtherMatMenu();
			}, 190);
		} else {
			this.closeAllOtherMatMenu(activeDropdown);
		}
	}

	closeAllOtherMatMenu(activeDropdown: MenuHoverDirective) {
		this.closeAllOtherMatMenuTimer = setTimeout(() => {
			this.hoverTriggers?.toArray().forEach((elem) => {
				if (activeDropdown !== elem) {
					elem.closeMenu();
				}
			});
			this.clearCloseAllOtherMatMenu();
		}, 190);
	}

	clearCloseAllOtherMatMenu() {
		if (this.closeAllOtherMatMenuTimer) {
			clearTimeout(this.closeAllOtherMatMenuTimer);
			this.closeAllOtherMatMenuTimer = null;
		}
	}

	openExternalLink(link) {
		if (link) {
			window.open(link);
		}
	}

	openModernPreloadModal() {
		this.dialogService.openModernPreloadModal();
	}

	updateActiveItem(id: string): boolean {
		if (id === 'security') {
			return (
				this.currentRoutePath === '/home-security' ||
				this.currentRoutePath?.startsWith('/security')
			);
		}
		if (id === 'support') {
			return (
				this.currentRoutePath === '/hardware-scan' ||
				this.currentRoutePath?.startsWith('/support')
			);
		}
		return false;
	}
	identify(index, item) {
		return item.id;
	}
}
